import { DefaultButton } from "../button/defaultButton/DefaultButton";
import styles from "./FiltersPanelActions.module.scss";

interface IFiltersPanelActionsProps {
  onApply: () => void;
  onClearAll: () => void;
  applyLabel?: string;
  clearAllLabel?: string;
}

/**
 * "Приложи филтрите" / "Изчисти всички" footer of a FiltersSidePanel.
 * Filters are applied live, so "apply" only closes the panel.
 */
export const FiltersPanelActions = ({
  onApply,
  onClearAll,
  applyLabel = "Приложи филтрите",
  clearAllLabel = "Изчисти всички",
}: IFiltersPanelActionsProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.root_group}>
        <DefaultButton label={applyLabel} design="default" onClick={onApply} />
        <DefaultButton
          label={clearAllLabel}
          design="outline"
          onClick={onClearAll}
        />
      </div>
    </div>
  );
};
